import React, { Component } from "react";
import { ChipField } from "react-admin";
import { withStyles } from "@material-ui/core";

const styles = theme => ({
    chip: {
        cursor: "pointer"
    }
});
class MyChipField extends Component {
    render() {
        const { source, record, classes } = this.props;
        if (record) {
            return (
                <ChipField
                    source={source}
                    record={record}
                    className={classes.chip}
                />
            );
        } else {
            return null;
        }
    }
}

export default withStyles(styles)(MyChipField);



// WEBPACK FOOTER //
// ./src/components/MyChipField.js